import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const MaxRateEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (value: string) => {
    if (!contract) return;

    let processedValue: number | null = null;
    if (value !== '' && value !== null) {
      processedValue = parseFloat(value) || null;
    }

    dispatch(updateSelectedContract({
      unspecified: {
        ...contract.unspecified,
        maxRate: processedValue
      }
    }));
  };

  if (!contract) return null;

  return (
    <TextField
      label="Max Rate"
      value={contract.unspecified?.maxRate || ''}
      onChange={(e) => handleChange(e.target.value)}
      type="number"
      inputProps={{
        step: 0.01,
        min: 0
      }}
      fullWidth
      size="small"
      variant="outlined"
      helperText="Maximum rate limit for unspecified services"
    />
  );
};

export default MaxRateEditor;